import React from 'react'

const FlagFI: React.FC<React.SVGProps<SVGSVGElement>> = ({ ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 900 600" {...rest}>
    <rect width="900" height="600" fill="#fff" />
    <rect width="900" height="150" y="225" fill="#002F6C" />
    <rect width="150" height="600" x="250" fill="#002F6C" />
  </svg>
)

export default FlagFI 